<template>
    <div v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_LIST')">
      <div class="breadcrumb-area pos-relative w-100">
        <h1>Merchant contract</h1>
      </div>
      <!-- <b-breadcrumb :items="[
        {
          text: 'Home',
          href: '/'
        }, {
          text: 'Merchant owner',
          href: '#'
        }
      ]" /> -->

      <b-card>
        <template #header>
          <FilterData :isShowBtnAdd="true" @search="onSearch" @add="onAddClick"/>
        </template>

        <p>Tổng số bản ghi: <strong class="text-primary">{{ pagination.total }}</strong></p>
        <b-table bordered hover head-variant="light" :items="list" :fields="fields" fixed show-empty responsive :busy.sync="isLoading">
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle" />
            </div>
          </template>
          <template #empty>
            <div class="text-center text-info my-2">
              Không có dữ liệu
            </div>
          </template>
          <template #emptyfiltered="{ emptyFilteredText }">
            <h4>{{ emptyFilteredText }}</h4>
          </template>

          <template #cell(mobile)="{ value }">
            {{ value | encryptPhone }}
          </template>

          <template #cell(createdDate)="{ value }">
            {{ value | formatDate('HH:mm DD/MM/YYYY') }}
          </template>

          <template #cell(lastModifiedDate)="{ value }">
            {{ value | formatDate('HH:mm DD/MM/YYYY') }}
          </template>

          <template #head(actions)="{ label }">
            <div>{{ label }}</div>
          </template>

          <template #cell(actions)="{ item, index }">
            <b-button variant="outline-primary" size="sm" @click="onDetailClick(item)">
              <b-icon icon="info-square" aria-hidden="true" />
            </b-button>
            <b-button variant="outline-primary" size="sm" @click="onEditClick(item)">
              <b-icon icon="pencil-square" aria-hidden="true" />
            </b-button>
          </template>

          <template #table-caption>
            <b-pagination
              v-model="pagination.page"
              :total-rows="pagination.total"
              :per-page="pagination.limit"
              class="fl-right"
            ></b-pagination>
          </template>
        </b-table>
      </b-card>

      <PopupAdd ref="popupAddRef" @fetch-data="onSearch" />
    </div>
  </template>

  <script>
    import { mapGetters } from 'vuex'
    import FilterData from './components/Filter.vue';
    import { List } from '@/services/customer-support/contract'
    import { showMess } from '@/config/utils'
    import PopupAdd from './components/PopupAdd.vue'

    export default {
      components: {
        FilterData,
        PopupAdd
      },
      data () {
        return {
          isLoading: false,
          pagination: {
            queryString: '',
            sortField: '',
            sortType: '',
            page: 1,
            total: 0,
            limit: 20,
          },
          fields: [
            {
              key: 'contractCode',
              label: 'Mã hợp đồng',
              sortable: false,
            },
            {
              key: 'ownerName',
              label: 'Tên',
              sortable: false,
            },
            {
              key: 'customerId',
              label: 'customer Id',
              sortable: false,
            },
            {
              key: 'createdDate',
              label: 'Created at',
              sortable: false,
            },
            {
              key: 'lastModifiedDate',
              label: 'Updated at',
              sortable: false,
            },
            {
              key: 'actions',
              label: 'Actions',
              sortable: false,
            }
          ],
          list: []
        }
      },

      filters: {
      },

      created () {
        // this.loadData();
      },

      mounted () {

      },

      computed: {
        ...mapGetters({
          dataPermission: 'role/dataPermission',
        }),
      },

      methods: {
        onSearch ({queryString, sortField, sortType}) {
          this.pagination.queryString = queryString;
          this.pagination.sortField = sortField;
          this.pagination.sortType = sortType;
          this.pagination.page = 1;
          this.loadData();
        },

        async loadData () {
          try {
            this.isLoading = true;
            const res = await List({
              limit: this.pagination.limit,
              page: this.pagination.page,
              queryString: this.pagination.queryString,
              sort: {
                direction: this.pagination.sortType,
                properties: [this.pagination.sortField],
              }
            });
            this.list = res.data;
            this.pagination.total = res.paging.total;
          } catch (e) {
            showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          } finally {
            this.isLoading = false;
          }
        },

        onEditClick(item) {
          this.$refs.popupAddRef.show(item);
        },

        onAddClick() {
          this.$refs.popupAddRef.show();
        },

        onDetailClick(item) {
          this.$router.push(`/customer-support/contract/${item.id}`);
        },
      }
    }
  </script>

  <style scoped>
  .breadcrumb {
    margin-bottom: 0;
  }
  .card-footer {
    background-color: #fff;
    border-top: none !important
  }
  .pagination {
    margin: 0 !important;
  }

  .btn {
    & + .btn {
      margin-left: 6px;
    }
  }
  </style>
